import { EventEmitter } from '@angular/core';
import { UrlList } from './main/pages/authentication/shared/url-list.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class NavigationService {
    constructor(http) {
        this.http = http;
        this.onProfileUpdated = new EventEmitter();
    }
    getNavigationList(user) {
        return this.http.post(UrlList.URL_SECURITY + UrlList.GET_NAVIGATION, user);
    }
    updateProfile(user) {
        this.onProfileUpdated.emit(user);
    }
}
NavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.ɵɵinject(i1.HttpClient)); }, token: NavigationService, providedIn: "root" });
